import FullLayout from '@/layouts/full/FullLayout.vue';
import type { RouteRecordRaw } from 'vue-router';

/**
 * Faturas TI — rota de permissão única `/tecnologia/faturas-ti` (migration 353), FECHADA por padrão.
 * member vê · editor anexa · admin envia e configura. Configurações e cadastro herdam o nível desta rota
 * (resolveUserRouteAccessLevel, userRouteAccess.ts); a tela esconde as ações por nível com useUserPermissions('/tecnologia/faturas-ti').
 */
export const faturasTiRoutes: RouteRecordRaw[] = [
  {
    path: '/tecnologia/faturas-ti',
    component: FullLayout,
    meta: { requiresAuth: true, title: 'Faturas TI' },
    children: [
      { path: '', name: 'FaturasTi', component: () => import('@/views/FaturasTi/FaturasTiPage.vue'), meta: { requiresAuth: true, title: 'Faturas TI', breadcrumb: 'Tecnologia / Faturas TI' } },
      { path: 'configuracoes', name: 'FaturasTiConfig', component: () => import('@/views/FaturasTi/config/FaturasTiConfigPage.vue'), meta: { requiresAuth: true, title: 'Faturas TI · Configurações', breadcrumb: 'Faturas TI / Configurações' } },
      { path: 'contas/nova', name: 'FaturasTiContaNova', component: () => import('@/views/FaturasTi/config/ContaCadastroPage.vue'), meta: { requiresAuth: true, title: 'Nova conta', breadcrumb: 'Faturas TI / Configurações / Nova conta' } },
      { path: 'contas/:id', name: 'FaturasTiContaEditar', component: () => import('@/views/FaturasTi/config/ContaCadastroPage.vue'), meta: { requiresAuth: true, title: 'Editar conta', breadcrumb: 'Faturas TI / Configurações / Conta' } },
    ],
  },
];
export default faturasTiRoutes;
